import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#C8D8FF'}
      d="M22.65 24.498v-.26c0-5.44-4.43-9.87-9.87-9.87-5.44 0-9.87 4.43-9.87 9.87v.26H.69v-.26c0-5.07 3.13-9.55 7.84-11.31a7.005 7.005 0 0 1-1.63-1.76c-2.11-3.25-1.19-7.6 2.06-9.71a6.997 6.997 0 0 1 3.82-1.13c2.39 0 4.59 1.19 5.89 3.2 2.01 3.1 1.26 7.21-1.63 9.41 4.71 1.77 7.84 6.25 7.84 11.31v.26h-2.21l-.02-.01Zm-9.87-21.96c-2.65 0-4.81 2.16-4.81 4.81 0 2.65 2.16 4.81 4.81 4.81 2.65 0 4.81-2.16 4.81-4.81 0-2.65-2.16-4.81-4.81-4.81Z"
    />
    <Path
      fill={props.fill || '#C8D8FF'}
      d="M16.46 12.997a6.751 6.751 0 0 0 1.98-9.35 6.751 6.751 0 0 0-9.35-1.98 6.751 6.751 0 0 0-1.98 9.35c.52.79 1.19 1.47 1.98 1.98a11.812 11.812 0 0 0-8.14 11.23h1.69c0-5.6 4.54-10.14 10.14-10.14 5.6 0 10.14 4.54 10.14 10.14h1.69c0-5.11-3.29-9.64-8.14-11.23h-.01Zm-8.75-5.66a5.07 5.07 0 1 1 10.14 0 5.07 5.07 0 0 1-10.14 0Z"
    />
  </Svg>
);
export default SvgComponent;
